import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppService } from '@irb/app.service';
import { IPortfolioResultACCRebal } from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';

@Component({
  selector: 'irb-com-pr-cash-values-account-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './com-pr-cash-values-account-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ComPrCashValuesAccountOverlayComponent {
  @Input() row: IPortfolioResultACCRebal | null = null;

  isDistHoldCashEnabled: boolean;
  isCashEqvEnabled: boolean;

  constructor(private as: AppService) {
    const irbAppConfig = this.as.getItem('IRB_APP_CONFIG');
    this.isDistHoldCashEnabled = irbAppConfig?.featureFlags?.isDistHoldCashEnabled || false;
    this.isCashEqvEnabled = irbAppConfig?.featureFlags?.isCashEqvEnabled || false;
  }
}
